import { Form, FormInstance } from 'antd'
import { Locale, NL_NL } from '../user/locale'

export const DEFAULT_CAMPAIGN_LOCALE: Locale = NL_NL

export function useCampaignLocale(form: FormInstance): Locale {
    return Form.useWatch('locale', { form, preserve: true }) ?? DEFAULT_CAMPAIGN_LOCALE
}

export function languageOf(locale: string) {
    return locale.toLowerCase().split(/[_-]/)[0]
}
